<template>
  <div 
    class="assistant-card"
    :class="{ 'favorite-layout': is_favorite_layout, 'drag-and-drop': !show_favorite_action }"
    @click="$emit('card-click', assistant)"
  >
    <div class="card-content d-flex justify-content-between">
      <div class="card-info p-1">
        <div class="avatar-container">
          <div v-if="is_favorite_layout" class="plus-avatar">
            <feather-icon icon="PlusIcon" size="24" class="text-white"></feather-icon>
          </div>
          <b-avatar 
            v-else
            :src="require(`@/assets/images/icons/${assistant.avatar}`)" 
            size="48"
            variant="light"
          ></b-avatar>
        </div>
        <div class="info-content">
          <div class="title-row">
            <template v-if="is_favorite_layout">
              <h6 class="assistant-title">{{ $t('ia.assistants.avaibleSlot') }}</h6>
            </template>
            <template v-else>
              <h6 class="assistant-title">{{ assistant.name }}</h6>
              <div class="title-icons" v-if="show_favorite_action">
                <b-button
                  :id="`tooltip-${assistant.id}`"
                  variant="link"
                  size="sm"
                  class="info-btn p-0"
                  @click.stop
                >
                  <feather-icon icon="InfoIcon" size="16"></feather-icon>
                </b-button>
                <b-tooltip :target="`tooltip-${assistant.id}`">{{ assistant.tooltip }}</b-tooltip>
                <b-badge v-if="assistant.isPro" variant="warning" class="pro-badge">
                  PRO
                </b-badge>
              </div>
            </template>
          </div>
          <p v-if="is_favorite_layout" class="assistant-description">
            {{ $t('ia.assistants.selectAModel') }}
          </p>
          <p v-else class="assistant-description">{{ assistant.description }}</p>
        </div>
      </div>
      
      <!-- actions  -->
    <div v-if="!is_favorite_layout" class="card-actions">
        <div
          class="favorite-btn"
          :class="{ 'favorited': assistant.isFavorite }"
          @click.stop="$emit('toggle-favorite', assistant)"
          v-if="show_favorite_action"
        >
          <b-icon 
            :icon="assistant.isFavorite ? 'heart-fill' : 'heart'"
            size="16"
            :class="{ 'text-danger': assistant.isFavorite }"
          ></b-icon>
        </div>
        <div v-else class="favorite-btn" title="Drag to reorder">
          <b-icon icon="grip-vertical" font-scale="1.1"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BTooltip,
} from 'bootstrap-vue';

export default {
  name: 'AssistantCard',
  components: {
    BAvatar,
    BBadge,
    BButton,
    BTooltip,
  },
  props: {
    is_favorite_layout: {
      type: Boolean,
      default: false
    },
    show_favorite_action: {
      type: Boolean,
      default: true
    },
    assistant: {
      type: Object,
      required: false,
      default: () => ({
        id: null,
        name: '',
        description: '',
        avatar: '',
        tooltip: '',
        isPro: false,
        isFavorite: false
      })
    }
  },
  emits: ['card-click', 'toggle-favorite']
}
</script>

<style lang="scss" scoped>
.assistant-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

    &:not(.favorite-layout):hover {
    background-color: #f2f1f18d;
    cursor: pointer;
  }

  &.favorite-layout {
    cursor: default;
  }
  &.drag-and-drop {
    cursor: grab !important;
  }
}

.card-content {
  height: 100%;
}

.card-info {
  display: flex;
  flex: 1;
  margin-right: 0.75rem;
}

.avatar-container {
  margin-right: 0.75rem;
  flex-shrink: 0;
  
  .plus-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: black !important;
    color: white;
  }
}

.info-content {
  flex: 1;
  min-width: 0;
}

.title-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
}

.assistant-title {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  margin-right: 0.5rem;
}

.title-icons {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}

.info-btn {
  color: #6c757d;
  
  &:hover {
    color: #007bff;
  }
}

.pro-badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.4rem;
}

.assistant-description {
  margin: 0;
  font-size: 0.8rem;
  color: #666;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-actions {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
}

.favorite-btn {
  width: 36px;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #dee2e6;
  background-color: #f8f9fa;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
  }
  
  &.favorited {
    background-color: #fff5f5;
    border-color: #fecaca;
    
    &:hover {
      background-color: #fef2f2;
      border-color: #f87171;
    }
  }
}
</style>